// extracted by mini-css-extract-plugin
export default {"wrap":"FullscreenModal_wrap__XgQgJ","modal":"FullscreenModal_modal__vrI4x","container":"FullscreenModal_container__v98CD"};